var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-lg p-4" }, [
    _c(
      "div",
      {
        staticClass:
          "slide d-flex align-items-center justify-content-around flex-wrap flex-lg-nowrap"
      },
      [
        _c("div", { staticClass: "titles-width" }, [
          _c("h2", [_vm._v(_vm._s(_vm.title))]),
          _c("p", [_vm._v(_vm._s(_vm.description))]),
          _vm.button
            ? _c(
                "a",
                {
                  staticClass: "btn btn-primary mb-3 slide-button",
                  attrs: {
                    href: _vm.button.href,
                    target: _vm.button.target,
                    role: "button"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.button.text[_vm.T.locale]) + " ")]
              )
            : _vm._e()
        ]),
        _c("div", [
          _c("img", {
            staticClass: "d-block image-width",
            attrs: { height: "320", src: _vm.imageSrc }
          })
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }